import React, { memo, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, Slider } from '@Sage/hoi-poi-ui';
import AvatarEditor from 'react-avatar-editor';
import { getLiteral } from 'utils/getLiteral';
import './CropImageDialog.scss';

const propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    image: PropTypes.any,
    cropperSize: PropTypes.number,
    type: PropTypes.object,
};

const CropImageDialog = memo(({ show, onClose, onAccept, image, cropperSize, type }) => {
    const cropperRef = useRef(null);
    const [scale, setScale] = useState(1.2);

    const handleAccept = useCallback(() => {
        if (cropperRef.current) {
            const canvas = cropperRef.current.getImage();
            onAccept(canvas.toDataURL());
        }
    }, [onAccept]);

    const handleScale = useCallback((value) => {
        setScale(value);
    }, []);

    const containerStyle = {
        position: 'relative',
        textAlign: 'center',
        margin: '0 auto',
        width: type?.width,
    };

    const borderDashStyle = {
        position: 'absolute',
        pointerEvents: 'none',
        ...type,
    };

    return (
        <Modal
            isOpen={show}
            onRequestClose={onClose}
            title={getLiteral('title_edit_photo')}
            onCancel={onClose}
            onConfirm={handleAccept}
            confirmText={getLiteral('action_accept')}
            cancelText={getLiteral('action_cancel')}
            size="small"
        >
            <div className="fm-crop-image-dialog">
                <div style={containerStyle}>
                    <div style={borderDashStyle} />
                    <AvatarEditor
                        image={image}
                        width={cropperSize}
                        height={cropperSize}
                        border={0}
                        color={[255, 255, 255, 1]}
                        scale={scale}
                        rotate={0}
                        borderRadius={type?.borderRadius ? cropperSize / 2 : 0}
                        ref={cropperRef}
                        style={{ cursor: 'move' }}
                    />
                </div>
                <Slider
                    min={0.7}
                    max={2.2}
                    step={0.1}
                    value={scale}
                    onChange={handleScale}
                    showValue={false}
                />
            </div>
        </Modal>
    );
});

CropImageDialog.propTypes = propTypes;
export default CropImageDialog;
